import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./common.scss";
import App from './App';
import reportWebVitals from './reportWebVitals';
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { OrdersContextProvider } from './context/orders.context';
import { ChatRefProvider } from './context/chatRef.context';
import { BrowserRouter } from "react-router-dom";
import './utils/firebase';
import { InstanceProvider } from './context/instance.context';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <InstanceProvider>
        <OrdersContextProvider>
            <ChatRefProvider>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </ChatRefProvider>
        </OrdersContextProvider>
    </InstanceProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
